export default __webpack_public_path__ + "static/media/thumb-bag.670232dd.png";